export default {
  /* Buttons */
  'buttons.login': 'Giriş',
  'buttons.forgotPass': 'Şifremi Unuttum',
  'buttons.send': 'Gönder',
  'buttons.confirm': 'Onayla',
  'buttons.cancel': 'İptal',
  'buttons.yes': 'Evet',
  'buttons.no': 'Hayır',
  'buttons.ok': 'Tamam',
  'buttons.goToLink': 'Linke Git',
  'buttons.cancelUpper': 'Vazgeç',
  'buttons.filter': 'Filtrele',
  'buttons.share': 'Paylaş',
  'buttons.reply': 'Cevapla',
  'buttons.delete': 'Sil',
  'buttons.forgotMyInfo': 'Bilgilerimi Unuttum',
  'buttons.close': 'KAPAT',
  'buttons.congratulate': 'Tebrik Et',
  'buttons.congratulated': 'Tebrik Ettin',
  'buttons.celebrate': 'Kutla!',
  'buttons.celebrated': 'Kutladın!',
  'buttons.search': 'Ara',
  'buttons.more': 'Daha fazla yükle',
  'buttons.thanks': 'Teşekkür Et',
  'buttons.answerSurvey': 'Anketi Cevapla',
  'buttons.answeredSurvey': 'Anketi Cevapladınız...',
  'buttons.markAsRead': 'Tümünü Okundu Olarak İşaretle',
  'buttons.viewCount': 'kişi gördü',
  'buttons.changePhoto': 'Fotoğrafı Düzenle',
  'buttons.update': 'Düzenle',
  'buttons.edit': 'Güncelle',
  'buttons.logout': 'Çıkış Yap',
  'buttons.selectPhoto': 'Fotoğraf Seç',
  'buttons.deletePhoto': 'Fotoğrafı Sil',
  'buttons.save': 'Kaydet',
  'buttons.sendMessage': 'Mesaj Gönder',
  'buttons.addPhoto': 'Fotoğraf Ekle',
  'buttons.download': 'İndir',
  'buttons.sendRequest': 'Talep Gönder',
  'buttons.confirm': 'Onayla',
  'buttons.reject': 'Reddet',
  'buttons.startStream': 'Yayını Başlat',
  'buttons.endStream': 'Yayını Sonlandır',
  'buttons.gotoLink': 'Linke Git',

  /* Labels */

  'labels.forYou': 'Senin İçin Seçtiklerimiz',
  'labels.email': 'E-Mail',
  'labels.sicilNumber': 'Amansız Takip Numarası',
  // 'labels.sicilNumber': 'Sicil Numarası',
  'labels.password': 'Parola',
  'labels.verificationCode': 'Onay Kodu',
  'labels.allCountry': 'Tüm Gönderiler',
  'labels.myGroup': 'Kendi Bölümüm\n(Division)',
  'labels.myRegion': 'Bölge Seçiniz\n(Region)',
  'labels.selectGroup': 'Grup Seç',
  'labels.addTag': 'Etiket Ekle',
  'labels.addUser': 'Kişi Ekle',
  'labels.names': 'İsim Giriniz...',
  'labels.search': 'İçerik, kişi veya etiket ara',
  'labels.searchAcademy': 'Akademide Ara',
  'labels.searchPost': 'İçerik ara',
  'labels.searchUser': 'Kişi ara',
  'labels.searchTag': 'Etiket ara',
  'labels.area': 'Bölge',
  'labels.birthdate': 'Doğum Günü',
  'labels.about': 'İlgi Alanları',
  'labels.phone': 'Telefon',
  'labels.deleteMessage': 'Mesajı Sil',
  'labels.selectGroup': 'Grup Seçiniz',
  'labels.posts': 'Gönderiler',
  'labels.news': 'Battan Haberler',
  'labels.isPublic': 'Paylaşıma Açık Olsun',
  'labels.selectSort': 'Sıralama Seçiniz',
  'labels.selectStatus': 'Durum Seçiniz',
  'labels.selectCreatedAt': 'Yükleme Tarihi Seçiniz',
  'labels.selectCategory': 'Kategori Seçiniz',
  'labels.selectArea': 'Bölge Seçiniz',
  'labels.advertTitle': 'İlan Başlığı',
  'labels.advertDescription': 'İlan Açıklaması',
  'labels.advertPrice': 'Fiyat (ücretsiz ise 0 bırakın)',
  'labels.advertCity': 'Şehir (boş bırakılabilir)',
  'labels.advertContactInformation': 'İlan Sahibinin İletişim Bilgileri',

  /* Titles */
  'title.BATAcademyEducations': 'Eğitim Kütüphanesi',
  'title.BATAcademyEducationsDesc':
    'İş ve kişisel gelişimin için faydalı eğitimler burada seni bekliyor',
  'title.assignedToYou': 'Sana Atanan Eğitimler',
  'title.assignedToYouDesc':
    'Gerçek bir BAT temsilcisi olabilmen için tamamlaman gereken eğitimleri burada bulabilirsin',
  'title.certificates': 'Sertifikalar',
  'title.certificatesDesc':
    'Kazandığın sertifikaları bu alanda görüntüleyebilirsin',
  'title.vizgoContent': 'Vizgo İçerikleri',
  'title.forgotPassword': 'Şifremi Unuttum',
  'title.comments': 'Yorumlar',
  'title.agreementTitle': 'Sözleşme Metni',
  'title.content': 'Gönderi',
  'title.Thanks': 'Teşekkür Et',
  'title.notifications': 'Bildirimler',
  'title.viewCount': '{count} kişi görüntüledi',
  'title.batAcademi': 'BAT Akademi',
  'title.welcomeAcademy': '’ye Hoş Geldin!',
  'title.academySubtitle':
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  'title.or': 'ya da',
  'title.totalCount': '{count} sonuç bulundu.',
  'title.selectedCategoryName': 'Seçili kategori: {selectedCategoryName}',
  'title.lastVideo': 'En Son Yüklenen Videolar',
  'title.lastDocuments': 'En Son Yüklenen Dokümanlar',
  'title.mostLiked': 'En Çok Beğenilenler',
  'title.likedUsers': 'Beğenenler',
  'title.postShare': 'İçeriği Paylaş',
  'title.viewsUser': 'Görüntüleyenler',
  'title.liveStreamArchive': 'Canlı Yayın Arşiv',
  'title.liveStreamRequest': 'Canlı Yayın İstekleri',
  'title.adverts': 'İlanlar',
  'title.advertOwnerInfo': 'İlan Sahibi İletişim Bilgileri',
  'title.communityApps': 'Topluluk Uygulamaları',

  /* Description */
  'description.forgotPassword': 'Şifremi Gönder',
  'description.forgotPasswordPhoneNumber':
    'Telefon numaranızı başında sıfır olmadan giriniz.',
  'description.noContent': 'İçerik Bulunamadı. ',
  'description.searchDesc': '* Aramak istediğiniz grup ismini yazıp ',
  'description.pressButton': 'tuşuna basınız.',
  'description.successDeleteContent': 'İçerik başarıyla silindi.',
  'description.successEditContent': 'İçerik başarıyla güncellendi.',
  'description.successReport': 'Şikayetiniz başarıyla gönderildi.',
  'description.successDeletePin': 'Pin kaldırma işlemi başarılı',
  'description.successPin': 'Pinleme işlemi başarılı',
  'description.ifTagAdd': ' etiketini eklemek için ',
  'description.successShareContent': 'İçerik başarıyla paylaşılmıştır.',
  'description.forgotInformation':
    'Bilgilerinizi hatırlamıyorsanız bölge plannerınızdan kullanıcı adı ve şifrenizi alabilirsiniz.',
  'description.agreementTexts': 'Sözleşme metinlerini',
  'description.readAndApproval': ' okudum, onaylıyorum.',
  'description.sendedNotification': 'Arkadaşına bildirimin ulaştı.',
  'description.bestOfDescription':
    "BSP'nin enlerinde yerini alman için sabırsızlanıyoruz...",
  'description.sendThanks': 'Teşekkürünüz iletilmiştir',
  'description.successAnswerSurvey':
    'Anket Cevabınız başarıyla gönderilmiştir.',
  'description.unexpected':
    'Beklenmeyen bir hata oluştu, lütfen daha sonra yeniden deneyiniz.',
  'description.uploadLessFile':
    'Lütfen {count} megabayttan küçük dosya yükleyiniz.',
  'description.messageUserSearch': 'İsim Soyisim',
  'description.selectUserToMessage':
    'Mesajlaşmak istediğiniz kişiyi seçerek ya da üst kısımdaki arama çubuğundan aratarak konuşmaya başlayabilirsiniz.',
  'description.downloadButtonDescription':
    'İndir butonundan ilgili dökümanı indirebilirsiniz.',
  'description.unsuppertedFile': 'Desteklenmeyen dosya biçimi',
  'description.workContinues': 'Yapım Aşamasında',
  'description.deleteChat': 'Sohbet silinecek emin misiniz ?',
  'description.liveStreamRequestText':
    'adlı kullanıcı canlı yayın isteği gönderdi',
  'description.noPost': 'Gönderi bulunmamaktadır.',
  'description.transactionSuccessful': 'İşlem Başarılı',
  'description.liveStreamStartDescription':
    'Canlı yayını başlatmak ister misiniz?',
  'description.endLiveStream': 'Canlı yayın sonlanmıştır.',
  'description.noLiveStream': 'Canlı yayın bulunamadı.',
  'description.streamStarting': 'Canlı Yayın Başlatılıyor...',
  'description.streamStarted': 'Canlı Yayın Başladı',
  'description.streamNotStart': 'Canlı Yayın Başlatılamadı',
  'description.thanked': '{name} sana teşekkür etti.',
  'description.downloadAppInStore':
    '{name} uygulamasını telefonuna ücretsiz yükle',
  'description.removeAdvert':
    'İlanınızı yayından kaldırmak istediğinize emin misiniz',
  'description.editAdvert': 'İlanınızı Düzenleyin',
  'description.advertContactInfo':
    '“İlanla İlgileniyorum” butonu tıklandığında İlan Sahibi bilgisi otomatik olarak gösterilecektir. Lütfen size ulaşılmasını istediğiniz iletişim bilgisini (dahili numara/ cep numarası/ mail adresi), şeklini (sadece whatsapp, arama vb.) ve tercih ettiğini saatler gibi gerekli gördüğünüz diğer bilgileri bu alana giriniz.',
  'description.formControl': 'Lütfen tüm alanları eksiksiz doldurunuz.',
  'description.copyToClipboard': 'İçerik kopyalandı',
  'description.pinSuccess': 'İçerik başarıyla pinlendi',

  /* Menu */
  'menu.home': 'Anasayfa',
  'menu.announcements': 'İlanlar',
  'menu.applications': 'Uygulamalar',
  'menu.interaction': 'Etkileşim',
  'menu.profile': 'Profil Bilgileri',
  'menu.aboutMe': 'Hakkımda',
  'menu.myPosts': 'Gönderilerim',
  'menu.myLikes': 'Beğenilerim',
  'menu.academy': 'Akademi',
  'menu.social': 'Sosyal',
  'menu.logout': 'Çıkış Yap',
  'menu.delete': 'Sil',
  'menu.update': 'Düzenle',
  'menu.pinOne': '1. Sıraya Ekle',
  'menu.pinTwo': '2. Sıraya Ekle',
  'menu.pinThree': '3. Sıraya Ekle',
  'menu.deletePin': 'Pin Kaldır',
  'menu.report': 'Şikayet Et',
  'menu.batNews': 'Haberler',
  'menu.createPost': 'Gönderi Oluştur',
  'menu.createLive': 'Canlı Yayın Başlat',
  'menu.createRequestLive': 'Canlı Yayın Talebi Gönder',
  'menu.sortAZ': "A-Z'ye sırala",
  'menu.sortZA': "Z-A'ya sırala",
  'menu.sortOldToNew': 'Eskiden yeniye sırala',
  'menu.sortNewToOld': 'Yeniden eskiye sırala',
  'menu.dataLastOne': 'Son 1 Ay',
  'menu.dataLastTwo': 'Son 3 Ay',
  'menu.dataLastThree': 'Son 6 Ay',
  'menu.bornToday': 'Bugün Doğanlar',
  'menu.newComers': 'Yeni Katılanlar',
  'menu.bestOfBSP': "BSP'nin Enleri",
  'menu.thanks': 'Teşekkür Et',
  'menu.surveys': 'Anketler',
  'menu.pin': 'Sabitle',
  'menu.unPin': 'Sabitlemeyi Kaldır',
  'menu.showAll': 'Tümünü Göster',
  'menu.isAssginedToMe': 'Bana Atananlar',
  'menu.completedTrainings': 'Tamamlanan Eğitimler',

  /* Feeds */
  'feed.viewAllComment': 'yorumları görüntüle',
  'feed.views': 'Görüntüleme',
  'feed.shares': 'Paylaş',
  'feed.commentshares': 'Cevapla',
  'feed.comments': 'Yorum',
  'feed.allComments': 'yorumun tümünü gör',
  'feed.like': 'Beğen',
  'feed.userLike': 'kişi beğendi',

  /* Comment */
  'add.comment': 'Yorum yaz...',
  'add.commentAnswer': 'Cevabınız',
  'comment.send.success': 'Yorum gönderildi.',
  'comment.replyingTo': ' cevap veriyorsun.',

  /* PlaceHolder */
  'placeHolder.write': 'Yazınız...',
  'placeHolder.answer': 'Cevabını paylaş...',
  'placeHolder.writeMessage': 'Mesaj Yaz...',

  /* Tabs */
  'tabs.bestOfPost': 'En Çok Paylaşım Yapanlar',
  'tabs.bestOfComment': 'En Çok Yorum Yapanlar',
  'tabs.bestOfLike': 'En Çok Beğenenler',
  'tabs.posts': 'İçerikler',
  'tabs.users': 'Kişi',
  'tabs.tags': 'Etiket',
  'tabs.ayLavBlog': 'BSP+',
  'tabs.batAcademy': 'Bat Akademi',
  'tabs.news': 'Haberler',
  'tabs.myAbout': 'Hakkımda',
  'tabs.myPost': 'Gönderilerim',
  'tabs.myLike': 'Beğendiklerim',
  'tabs.otherAbout': 'Hakkında',
  'tabs.otherPost': 'Gönderiler',

  /* Tooltips */
  'tooltips.createNewChat': 'Yeni Sohbet',
};
